import { computed, ref } from 'vue'

import { storeToRefs } from 'pinia'
import { useCartStore } from '@/stores/customer/cart'

import { useDiscountsAndSum } from '@/composables/useDiscountsAndSum'

export const useCartStarter = () => {
  const cartStore = useCartStore()
  const {
    cartItems,
    cartItemsAmount,
    coupon,
    giftcard,
    products,
    discounts,
    sum,
    split,
    cartIsLoading,
  } = storeToRefs(cartStore)

  const {
    couponEntity,
    giftcardEntity,

    totalSum,
    discountedSum,

    personalDiscountSum,
    couponDiscountSum,

    finalDiscountSum,

    finalDiscountEntity,
  } = useDiscountsAndSum(discounts, sum)

  const couponModel = ref(coupon.value)
  const giftcardModel = ref<{ code: string; confirmation?: string } | null>(
    giftcard.value?.[0] ?? { code: '', confirmation: '' }
  )

  const couponVerified = ref(false)
  const giftcardVerified = ref(false)
  const giftcardError = ref(false)

  const couponError = computed(() => {
    if (
      coupon.value === null ||
      coupon.value !== couponModel.value ||
      cartIsLoading.value
    ) {
      return false
    }

    return !couponEntity.value
  })
  // const giftcardError = computed(() => {
  //   if (
  //     giftcard.value === null ||
  //     giftcard.value !== giftcardModel.value ||
  //     cartIsLoading.value
  //   ) {
  //     return false
  //   }

  //   return !giftcardEntity.value
  // })

  async function sendCart() {
    if (!cartItems.value.length) return

    applyCoupon()
    applyGiftCard()

    const { error, validationErrors } = await cartStore.sendCart()

    couponVerified.value = !error && !validationErrors.coupon
  }

  function reset() {
    if (couponError.value || (!couponError.value && !couponEntity.value)) {
      coupon.value = null
    }
    
    couponVerified.value = false
    couponModel.value = coupon.value
  }

  function fullReset(toTheRoot = false) {
    cartStore.resetProducts()

    if (cartItems.value.length && !toTheRoot) return

    cartStore.resetCart()
    reset()
  }

  function applyCoupon() {
    if (!couponModel.value) return

    coupon.value = couponModel.value
  }
  function applyGiftCard() {
    console.log('giftcardModel.value', giftcardModel.value)
    console.log('giftcard.value', giftcard.value)

    if (!giftcardModel.value) return

    giftcard.value = giftcardModel.value
    // giftcard.value = giftcardModel.value
  }

  async function verifyGiftcard() {
    if (!giftcardModel.value.code) return

    try {
      const { success } = await cartStore.checkGiftcard(
        giftcardModel.value.code
      )
      if (!success) {
        giftcardError.value = true
      } else {
        giftcardError.value = false
      }
      giftcardVerified.value = success
    } catch (error) {
      giftcardError.value = true
    }
  }

  return {
    cartStore,

    products,
    cartIsLoading,
    cartItems,
    cartItemsAmount,
    coupon,
    giftcard,
    split,

    couponModel,
    giftcardModel,
    couponVerified,
    giftcardVerified,
    couponError,
    giftcardError,

    totalSum,
    discountedSum,
    personalDiscountSum,
    couponDiscountSum,
    finalDiscountSum,
    finalDiscountEntity,

    sendCart,
    reset,
    fullReset,
    verifyGiftcard,
  }
}
